import * as yup from "yup";

export const formSchema = yup.object().shape({
  email: yup.string().email(),
  ssn4: yup.string(),
  phone: yup.number().min(10).max(15),
});
